import classNames from 'classnames/bind';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons/faCheckSquare';
import { faSquare } from '@fortawesome/pro-light-svg-icons/faSquare';

import { isIOS, isIOS13 } from 'react-device-detect';
import RoundRadioButton from '../../../GeneralComponents/RoundRadioButton';
import RangeSlider from './RangeSlider';

import Styles from './styles.module.scss';
import UpgradeTooltipSmall from '../../../GeneralComponents/UpgradeTooltip/UpgradeTooltipSmall';
import Tooltip from '../../../Tooltip';
import PlayVideoComponent from '../../../PlayVideoComponent';

const cx = classNames.bind(Styles);

const FilterInner = ({
  sentimentFilter, handleChangeFilterType, options, handleCategoriesChange,
  minRange, maxRange, handleRangeChange, hasAccess, hasBigScreenDesign, selectAllStatus, selectAll,
}) => (
  <div className={cx('sentiment_filer_menu')}>
    <div className={Styles.filter_title_holder}>
      <div className={Styles.filter_tag_holder}>
        {!hasAccess && <UpgradeTooltipSmall planBadgeText="SILVER" cssClass={Styles.premium_badge} />}
      </div>
      <div className={Styles.filter_title}>
        Sentiment Level:
        <Tooltip className={cx('stories-group-tooltip', { ios: isIOS || isIOS13 })}>
          Sentiment quantifies how news and social media feel about this topic.
          <div><a href="https://www.cityfalcon.ai/features/sentiment" className={cx('tooltip_link')}>How does it work?</a></div>
        </Tooltip>
        <PlayVideoComponent
          videoLink="https://cityfalcon.wistia.com/medias/362922bfs9"
          videoLinkMobile="https://cityfalcon.wistia.com/medias/xxio1ni47b"
          additionalStyles={cx('sentiment_play_button')}
          tooltipAdditionalContentStyle={cx('sentiment_play_button_tooltip')}
        />
      </div>
    </div>
    <div className={cx({ disable: !hasAccess, big_screen: hasBigScreenDesign })}>
      <RoundRadioButton
        name="Categories"
        filterItemInfo="categories"
        value="categories"
        customClass={Styles.sentiment_categories}
        selectedFilterValue={sentimentFilter}
        setValue={handleChangeFilterType}
        hasBigScreenDesign={hasBigScreenDesign}
      />
      <div className={cx('categories_options', { disable: sentimentFilter !== 'categories' })}>
        <Dropdown.Item
          active={selectAllStatus}
          onClick={selectAll}
        >
          <FontAwesomeIcon icon={selectAllStatus ? faCheckSquare : faSquare} />
          <div className={cx('row_title', 'selectall')}>Select / Unselect All</div>
        </Dropdown.Item>
        {
          options.map(({
            id, name, value, select,
          }) => (
            <CategoriesRow
              key={id}
              name={name}
              value={value}
              select={select}
              onSelect={handleCategoriesChange}
            />
          ))
        }
      </div>
      <RoundRadioButton
        name="Range"
        filterItemInfo="range"
        value="range"
        customClass={Styles.sentiment_range}
        selectedFilterValue={sentimentFilter}
        setValue={handleChangeFilterType}
        hasBigScreenDesign={hasBigScreenDesign}
      />
      <div className={cx('range_slider', { disable: sentimentFilter !== 'range' })}>
        <RangeSlider
          minRange={minRange}
          maxRange={maxRange}
          handleRangeChange={handleRangeChange}
          hasBigScreenDesign={hasBigScreenDesign}
        />
      </div>
    </div>
  </div>
);

const CategoriesRow = ({
  name, value, select, onSelect,
}) => (
  <Dropdown.Item eventKey={value} active={select} onSelect={onSelect}>
    <FontAwesomeIcon icon={select ? faCheckSquare : faSquare} />
    <div className={Styles.row_title}>{name}</div>
  </Dropdown.Item>
);

export default FilterInner;
